import React from 'react';
import { images } from '../data/links';
import { SectionCta } from './SectionCta';
export function AuthorNote() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" aria-labelledby="author-title" data-id="element-20" data-mp="37qzxq1l093h5">
      <div className="mx-auto max-w-5xl lg:grid lg:grid-cols-[0.8fr_1.2fr] lg:gap-14" data-id="element-21" data-mp="2su97oix81447">
        <div className="lg:sticky lg:top-10 lg:self-start" data-id="element-22" data-mp="2xt3ojfbmoilo">
          <img src={images.author} alt="Dr. Elowen Varelli in her pediatric therapy office" className="mx-auto w-full max-w-sm rounded-3xl object-cover lg:max-w-none" data-id="element-23" data-mp="3lhmwtuuogvdr" />
          <p className="mt-4 text-center font-heading text-xl font-semibold text-ink lg:text-left" data-id="element-24" data-mp="3bs3gavuftdm2">Dr. Elowen Varelli</p>
          <p className="text-center text-sm text-ink/60 lg:text-left" data-id="element-25" data-mp="3gpv3xdo1udkg">Creator of the Praxis & Motor Planning Clinical Pathway™</p>
        </div>

        <div className="mt-10 lg:mt-0" data-id="element-26" data-mp="890ccucpcflo">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand sm:text-sm" data-id="element-27" data-mp="d2cwar6fry83">Why I created the pathway</p>
          <h2 id="author-title" className="mt-3 font-heading text-[1.9rem] font-semibold leading-tight text-ink sm:text-4xl" data-id="element-28" data-mp="3ek7expc8yiap">
            A Note From Dr. Elowen Varelli
          </h2>
          <div className="mt-6 space-y-4 text-[1.05rem] leading-relaxed text-ink/80" data-id="element-29" data-mp="3o9h4axfphmv4">
            <p data-id="element-30" data-mp="3jhz3qahlhoao">
              Over the years, I’ve reflected on a challenge that can make pediatric occupational therapy cases particularly
              difficult to organize.
            </p>
            <p data-id="element-31" data-mp="3sb2o72qnr1et">
              You can study motor planning, become familiar with praxis-related concepts, review professional resources, and
              learn about different theoretical frameworks. But when you’re faced with a child who struggles with unfamiliar
              activities, movement sequences, or imitation tasks, a different question often emerges:
            </p>
            <p className="border-l-4 border-cta pl-4 font-heading text-xl font-medium text-ink" data-id="element-32" data-mp="27uz5ei2td4w9">
              “How do I organize everything I’m observing before deciding what it might mean?”
            </p>
            <p data-id="element-33" data-mp="31kgc3pjh5ekc">That’s the question that inspired the Praxis & Motor Planning Clinical Pathway™.</p>
            <p data-id="element-34" data-mp="36k2qw3eyb2v9">
              Not another enormous collection of disconnected information. Not a resource that encouraged you to assign a
              praxis-related explanation to every motor difficulty. And certainly not a tool that claimed to replace
              professional judgment or appropriate assessment.
            </p>
            <p data-id="element-35" data-mp="3kiixluctctde">
              Instead, I brought together visual maps, task analysis worksheets, reasoning matrices, and fictional case
              exercises in one practical framework — one that helps you organize the available information, recognize what’s
              missing, consider alternative explanations, and identify what may deserve further investigation.
            </p>
            <p data-id="element-36" data-mp="81e0fzhl670a">
              Because a child’s difficulty during a motor activity doesn’t always tell you, by itself, why that difficulty
              occurs. Task demands, prior experience, instructions, context, and other factors may all be relevant.
            </p>
            <p className="font-semibold text-ink" data-id="element-37" data-mp="1im1vqg3t0v5v">
              You don’t need to have every answer immediately. You need a structured way to work through the questions.
            </p>
            <p data-id="element-38" data-mp="1dpbkq76uwprb">
              My hope is that the pathway becomes a useful part of your professional learning toolkit and helps you approach
              complex cases with a more systematic process. Thank you for allowing me to be part of your professional
              journey.
            </p>
            <p className="font-heading text-lg italic text-ink" data-id="element-39" data-mp="21ijon0ue313p">— Dr. Elowen Varelli</p>
          </div>
        </div>
      </div>
      <SectionCta label="I’m ready to organize my reasoning" data-id="element-40" data-mp="2u1qmlik6ieby" />
    </section>;
}